module.exports = __webpack_public_path__ + "img/agital-online-logo.01d2b1f.svg";